import AdditionApi from '@/api/piglet/pigletAdditionApi';

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async addOrUdpdate({dispatch}, form) {
      try {
        const response = await AdditionApi.addOrUpdate(form);
        return Promise.resolve(response.data)
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async fetchAll({dispatch}) {
      try {
        const response = await AdditionApi.fetchAll();
        return Promise.resolve(response.data)
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    },
    async remove({dispatch}, {id}) {
      try {
        const response = await AdditionApi.remove(id);
        return Promise.resolve(response.data)
      } catch(error) {
        dispatch('NOTIFY_ERROR', error, {root: true});
        return await Promise.reject(error);
      }
    }
  }
}
